export const ERROR_BANNER = {
  TITLE: 'Technical Error',
  DESCRIPTION: 'Oops! Something went wrong. Please refresh or try again later.',
  BUTTON_TEXT: 'Refresh',
};
